export const textStyleElements = ["strong", "em", "sub", "sup", "code"];
export const blockElements = ["p", "h1", "h2", "h3", "h4", "h5", "h6"];
export const ignoredElements = ["img", "tbody", "ol", "ul"];
export const tableElements = ["table", "td", "tr"];
export const lineBreakElement = "br";
export const anchorElement = "a";
export const objectElement = "object";
export const assetElement = "figure";
export const listItemElement = "li";
export const markElements = [...textStyleElements, anchorElement];
export const allElements = [
    ...blockElements,
    ...ignoredElements,
    ...markElements,
    ...tableElements,
    assetElement,
    objectElement,
    lineBreakElement,
    listItemElement,
];
